import { useContext } from 'react';

import type { Authentication } from '@barboxx/models/types';

import { AuthContextProps } from '../context/AuthContext';

export function createUseAuth<T extends Authentication.AuthReturn>(
    AuthContext: React.Context<AuthContextProps<T>>
) {
    return () => useContext(AuthContext);
}
